import { SideSheet } from "@callcenter/design-system"
import { useUnit } from "effector-react"

import { userAccountModel } from "../../models"
import { UserAccountForm } from "../user-account-form"

import styles from "./user-account.module.pcss"

export const UserAccount = () => {
  const actions = useUnit({ userAccountToggled: userAccountModel.userAccountToggled })

  const isUserAccountOpened = useUnit(userAccountModel.$isUserAccountOpened)

  return (
    <SideSheet
      wrapperClassName={styles.sideSheetWrapper}
      isOpen={isUserAccountOpened}
      setIsOpen={actions.userAccountToggled}
    >
      <UserAccountForm />
    </SideSheet>
  )
}
